import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import useLocalization from 'hooks/useLocalization';
import { useSelector } from 'store';

/**
 * באנר חשבון חסום (שלב ב'): מוצג כשהשרת החזיר blockedReason בסטטוס החשבון —
 * תקופת ניסיון שהסתיימה או חשבון שסומן לא פעיל. במצב הזה כל המודולים חוזרים
 * ככבויים והשליחה חסומה בשרת; הבאנר הוא ההסבר למשתמש.
 */
export default function AccountBlockedBanner() {
  const { currentLocale } = useLocalization();
  const blockedReason = useSelector((state) => state.accountModules.data?.blockedReason ?? null);

  if (!blockedReason) return null;

  const t = currentLocale.accountBlockedBanner;
  const message = blockedReason === 'TRIAL_EXPIRED' ? t.trialExpired : t.inactive;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        maxWidth: '100%',
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        bgcolor: 'error.main',
        color: 'error.contrastText',
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 20 }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {message}
      </Typography>
    </Box>
  );
}
